import styled from 'styled-components'

const AddItemFormWrapper = styled.div`
  .paste-btn {
    margin-left: 20px;
  }

  .alert-not-found {
    color: red;
  }
  
  .back-button {
    margin-right: 12px;
  }
  
  .list-action {
    margin-bottom: 24px
  }
  
  .stay-right {
    float: right;
  }
  
  .bold {
    font-weight: bold;
  }

  .scalability-price-section {
    margin-top: 8px;
  }

  .tier-text {
    font-size: 12px;
    margin-bottom: 4px;
  }
`

export default AddItemFormWrapper
